import GeoCombobox from '../../../../../components/common/GeoCombobox';

/**
 * A division / district / upazila box for the printed-form tools: the app's
 * GeoCombobox dressed in the form's own input style, with its error line.
 *
 * `selectOnly` for lists that are complete (division, district). Upazila leaves
 * typing open — thanas, city-corporation areas and old names are not all listed.
 */
export default function GeoSelectField({
    id,
    value,
    onChange,
    onSelectOption,
    options,
    placeholder,
    error,
    selectOnly = false,
    inputClassName,
}) {
    const hasError = Boolean(error);
    return (
        <div id={id}>
            <GeoCombobox
                value={value}
                onChange={onChange}
                onSelectOption={onSelectOption}
                options={options}
                placeholder={placeholder}
                selectOnly={selectOnly}
                clearable={!selectOnly}
                className={inputClassName}
            />
            {hasError && typeof error === 'string' && error.trim() ? (
                <p className="mt-1 text-[11px] text-red-600 dark:text-red-400">{error}</p>
            ) : null}
        </div>
    );
}
